import Logger from 'forms-utils-lib/logger/Logger';
import useStorage from 'ui-forms-components/hooks/useStorage';
const useLocalStorage = ({
  key
}) => useStorage({
  key,
  applicationId: 'forms-ui',
  logger: Logger,
  isSession: false
});
export default useLocalStorage;